import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CourseItem from "../../components/CourseItem";
import MobileViewLayout from "../../layouts/MobileViewLayout";
import ApiService from "../../service/api";
import { checkLogin } from "../../slices/AuthSlice";
import { showErrorToast } from "../../utils/ToastsModal";
import { isValidArray } from "../../utils/modules";
import { Loader } from "../../widgets/Loader";

const Courses = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [courseList, setCourseList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    await ApiService.getCourseList()
      .then((res) => {
        if (res.status === 200) {
          setCourseList([...res.data]);
        } else if (res.status === 202) {
          setError(res.data.message);
          setTimeout(() => {
            localStorage.removeItem("token");
            dispatch(checkLogin());
          }, 6000);
        }
        setLoading(false);
      })
      .catch((err) => {
        const res = JSON.parse(err?.request?.response);
        showErrorToast(res.message, 5000);
        setLoading(false);
      });
  };

  return (
    <MobileViewLayout>
      <div className="px-1" style={{ marginBottom: "80px" }}>
        <h3
          className="text-black fw-bold text-center m-0 fs30 age-selection-heading"
          style={{ paddingTop: "20px", paddingBottom: "20px" }}
        >
          All Courses
        </h3>
        <div className="d-flex flex-column justify-content-around align-items-center List-card">
          {error ? <h6 className="mt-5 text-main px-4">{error}</h6> : <></>}
          {loading ? <Loader /> : <></>}
          {isValidArray(courseList) &&
            courseList?.map((course, index) => (
              <CourseItem
                data={course}
                onClick={() => {
                  navigate(`/courses/${course?.id}`, {
                    state: "coursesVideo",
                  });
                }}
                borderClass={
                  courseList?.length > 1 && index === 0
                    ? "border-bottom pt-0"
                    : index === courseList.length - 1
                    ? "pt-2"
                    : "border-bottom py-3"
                }
              />
            ))}
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default Courses;
